import type { ReactNode } from 'react';

export const symbol_replace_audio: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M810-620H640q-13 0-21.5-8.5T610-650q0-13 8.5-21.5T640-680h94q-42-66-109-103t-145-37q-90 0-164.5 46.5T204-648q-7 14-18 18t-22-1q-11-5-16-15.5t0-21.5q42-97 132.5-154.5T480-880q91 0 170.5 42.5T780-719v-101q0-13 8.5-21.5T810-850q13 0 21.5 8.5T840-820v170q0 13-8.5 21.5T810-620ZM328-118q-38-38-38-92t38-92q38-38 92-38 20 0 37.5 5t32.5 15v-220h180v60H550v270q0 54-38 92t-92 38q-54 0-92-38Z"
		/>
	</svg>
);
